import { BaseImage } from './image';
import {Picture} from '@core/services/picture';
import {IVideo} from '@api/models/video/video';


export class ActivityType {
  static readonly GOAL  = new ActivityType('GOAL', 'goal', 'Tor');
  static readonly OWN_GOAL  = new ActivityType('OWN_GOAL', 'own_goal', 'Eigentor');
  static readonly SUBSTITUTION  = new ActivityType('SUBSTITUTION', 'substitution', 'Wechsel');
  static readonly INJURY  = new ActivityType('INJURY', 'injury', 'Verletzung');
  static readonly YELLOW_CARD  = new ActivityType('YELLOW_CARD', 'yellow_card', 'Gelbe Karte');
  static readonly RED_CARD  = new ActivityType('RED_CARD', 'red_card', 'Rote Karte');
  static readonly YELLOW_RED_CARD  = new ActivityType('YELLOW_RED_CARD', 'yellow_red_card', 'Gelb-Rote Karte');
  static readonly TOP_CHANCE  = new ActivityType('TOP_CHANCE', 'top_chance', 'Topchance');
  static readonly TOP_PARADE  = new ActivityType('TOP_PARADE', 'top_parade', 'Topparade');
  static readonly TOP_TACKLE  = new ActivityType('TOP_TACKLE', 'top_tackle', 'Toptackle');
  static readonly GAME_ACTION  = new ActivityType('GAME_ACTION', 'game_action', 'Spielaktion');
  static readonly CARD  = new ActivityType('CARD', 'card', 'Karte');
  static readonly SHARING  = new ActivityType('SHARING', 'sharing', 'Teilen');
  static readonly LINEUP  = new ActivityType('LINEUP', 'lineup', 'Aufstellung');
  static readonly COMMENT  = new ActivityType('COMMENT', 'comment', 'Kommentar');
  static readonly PHASE_CHANGE  = new ActivityType('PHASE_CHANGE', 'phase_change', 'Spielphasenwechsel');
  static readonly THANK_YOU  = new ActivityType('THANK_YOU', 'thank_you', 'Danke');
  static readonly INFO  = new ActivityType('INFO', 'info', 'Info');

  static readonly FREE_KICK  = new ActivityType('FREE_KICK', 'free_kick', 'Tor (Freistoß)');
  static readonly PENALTY_GOAL  = new ActivityType('PENALTY_GOAL', 'penalty_goal', 'Freistoßtor');
  static readonly PENALTY_MISS  = new ActivityType('PENALTY_MISS', 'penalty_miss', 'Freistoß verfehlt');
  static readonly UNKNOWN  = new ActivityType('UNKNOWN', 'unknown', '');

  static readonly types: ActivityType[] = [
    ActivityType.GOAL,
    ActivityType.OWN_GOAL,
    ActivityType.SUBSTITUTION,
    ActivityType.INJURY,
    ActivityType.YELLOW_CARD,
    ActivityType.RED_CARD,
    ActivityType.YELLOW_RED_CARD,
    ActivityType.TOP_CHANCE,
    ActivityType.TOP_PARADE,
    ActivityType.TOP_TACKLE,
    ActivityType.GAME_ACTION,
    ActivityType.CARD,
    ActivityType.SHARING,
    ActivityType.LINEUP,
    ActivityType.COMMENT,
    ActivityType.PHASE_CHANGE,
    ActivityType.THANK_YOU,
    ActivityType.INFO,

    ActivityType.FREE_KICK,
    ActivityType.PENALTY_GOAL,
    ActivityType.PENALTY_MISS,
    ActivityType.UNKNOWN,
  ];

  static fromValue(value: string): ActivityType {
    for (let i = 0; i < this.types.length; i++) {
      if (this.types[i].value === value) {
        return this.types[i];
      }
    }

    return ActivityType.UNKNOWN;
  }

  // private to disallow creating other instances of this type
  private constructor(
    private readonly key: string,
    public readonly value: any,
    public readonly uiString: string,
  ) {}

  public stringForType(): string {
    return this.uiString;
  }
}

export class Activity {
  _id: string;
  _created: number;
  relative_timestamp: number;
  timestamp: number;

  activation_relative_to: number;
  activation: number;
  activation_milliseconds: number;

  typeAsObj: ActivityType;
  type: string;
  title: string;
  text: string;
  teamid: string;
  playerid: string;
  symbol: string;
  display_minute: string;
  images: BaseImage[];
  data: any;
  video: {
    preview_url: string,
    video_url: string
  };
  videos_native: IVideo[];
  playerImage: Picture[] = [];
  otherImages: Picture[] = [];
  teams: {
    home: {
      teamid: string;
      symbol: string;
    };
    away: { 
      teamid: string;
      symbol: string;
    };
  };


  public constructor(init?: Partial<Activity>) {
    this.typeAsObj = ActivityType.UNKNOWN;
    Object.assign(this, init);
    this.images = [];
    this.typeAsObj = ActivityType.fromValue(init.type);
  }

  getPlayerImage(): Picture {
    if (this.playerImage.length !== 0 && this.playerImage[0] != null) {
      return this.playerImage[0];
    }
    return null;
  }
}
